/**
 * Top Articles Carousel Implementation
 * Uses the generic carousel component with top-articles specific configuration
 */

import { GenericCarousel } from './carousel';

document.addEventListener('DOMContentLoaded', function () {
	// Check if the carousel element exists before initializing
	// This prevents errors when the feature flag is disabled
	const carouselElement = document.getElementById('top-articles-carousel');

	if (carouselElement) {
		// Initialize the top articles carousel using the generic carousel
		new GenericCarousel({
			carouselId: 'top-articles-carousel',
			prefix: 'top-articles',
			trackSelector: '.carousel-track',
			mobileBreakpoint: 768,
			cardsPerView: {
				mobile: 'auto', // Calculates based on container width
				desktop: 'auto', // Calculates based on container width
			},
			cardDimensions: {
				mobile: { width: 200, gap: 24 },
				desktop: { width: 330, gap: 16 },
			},
			orientation: {
				mobile: 'horizontal',
				desktop: 'horizontal',
			},
			swipeThreshold: 50,
		});
	}
});
